/**
 * Maps human-readable keys to Framer XLIFF translation unit IDs.
 * Used by the free-call page to look up translations from messages/{locale}.json.
 *
 * Most strings live in the "careers" namespace (the original Framer advisory-call page).
 */
export const freeCallKeys = {
  // Hero team strip
  roleRadiologist: "freeCallRoleRadiologist", // "Radiologist"
  roleCpo: "freeCallRoleCpo", // "Chief Product Officer"
  roleCeo: "freeCallRoleCeo", // "CEO"
  teamNote: "freeCallTeamNote", // "You will speak with a member of our patient team..."

  // Hero
  heroLabel: "heroLabel", // "TALK TO OUR TEAM"
  heroHeading: "heroHeading", // "Book your free 1-on-1 advisory call"
  heroSubtitle: "heroSubtitle", // "Our experts are here to help you understand..."
  scheduleCall: "scheduleCall", // "Schedule a call" (CTA button)

  // Value props section
  valuePropsHeading: "valuePropsHeading", // "Get expert advice before booking your scan"
  valuePropsDescription: "valuePropsDescription", // "Our advisory call is designed to help you..."
  valueProp1Title: "valueProp1Title", // "Clarification on our scan options"
  valueProp1Desc: "valueProp1Desc", // "Learn about our full-body MRI, blood tests..."
  valueProp2Title: "valueProp2Title", // "Personalized guidance"
  valueProp2Desc: "valueProp2Desc", // "Based on your lifestyle, health goals..."
  valueProp3Title: "home_freeCall_understandingTitle", // "Understanding the process" (manual key)
  valueProp3Desc: "valueProp3Desc", // "Get a breakdown of how our health assessments..."

  // How it works section
  howItWorksHeading: "howItWorksHeading", // "How the advisory call works"
  step1Title: "home_freeCall_step1Title", // "Book your call" (manual key — same text, diff context from bottom CTA)
  step1Desc: "step1Desc", // "Choose a time that works for you..."
  step2Title: "home_freeCall_step2Title", // "Speak with an expert" (manual key)
  step2Desc: "home_freeCall_step2Desc", // "One of our team members will walk you through..." (manual key)
  step3Title: "step3Title", // "Get personalized recommendations"
  step3Desc: "home_freeCall_step3Desc", // "Based on your health concerns..." (manual key)

  // Bottom CTA
  bottomCtaHeading: "bottomCtaHeading", // "Book your call"
  bottomCtaDescription: "home_freeCall_bottomCtaDesc", // "Ready to learn more?..." (manual key)
} as const
